import {
  ChangeEvent, InputHTMLAttributes, ReactElement, Ref,
} from 'react';
import { TFunction } from 'i18next';
import MaskedInput from 'react-text-mask';
import { TimeInput } from './styles';

/** Máscara HH:mm, a mesma das programações da tela atual. */
const TIME_MASK = [/[0-2]/, /\d/, ':', /[0-5]/, /\d/];

const TIME_24H_REGEX = /^([01]\d|2[0-3]):[0-5]\d$/;

/** Horário completo e válido no formato 24 h (`00:00` a `23:59`). */
export function isValidTime24h(value: string): boolean {
  return TIME_24H_REGEX.test(value);
}

/** Validação do horário inicial: obrigatório e válido, exceto no dia inteiro. */
export function validateStartTime(value: string, isFullDay: boolean, t: TFunction): true | string {
  if (isFullDay) return true;
  if (!value) return t('obrigatorio');
  return isValidTime24h(value) || t('horarioInvalido');
}

/** Validação do horário final: obrigatório, válido e maior que o inicial, exceto no dia inteiro. */
export function validateEndTime(value: string, start: string, isFullDay: boolean, t: TFunction): true | string {
  if (isFullDay) return true;
  if (!value) return t('obrigatorio');
  if (!isValidTime24h(value)) return t('horarioInvalido');
  return !start || value > start || t('horarioFinalMaiorInicial');
}

interface TimeInput24hProps {
  id: string;
  value: string;
  disabled: boolean;
  onChange: (value: string) => void;
  onBlur: () => void;
}

/**
 * Campo de horário em texto com máscara HH:mm. Substitui o `type="time"`, que segue a localidade do
 * navegador: em 12 h ele exibe AM/PM e converte 00:00 digitado em 12:00.
 */
export function TimeInput24h({
  id, value, disabled, onChange, onBlur,
}: Readonly<TimeInput24hProps>): ReactElement {
  return (
    <MaskedInput
      id={id}
      mask={TIME_MASK}
      guide={false}
      placeholder="HH:mm"
      inputMode="numeric"
      value={value}
      disabled={disabled}
      onChange={(event: ChangeEvent<HTMLInputElement>) => onChange(event.target.value)}
      onBlur={onBlur}
      render={(ref: Ref<HTMLInputElement>, props: InputHTMLAttributes<HTMLInputElement>) => <TimeInput ref={ref} {...props} />}
    />
  );
}
